import React from 'react';
import { Slide, IconButton, Button } from '@mui/material';
import { useSnackbar, SnackbarMessage, OptionsObject } from 'notistack';
import { Icon } from '@iconify/react';

type TSnackArgs = { message: SnackbarMessage; options?: OptionsObject };

const useSnackbarNotifications = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const closeBtn = (key: any) => (
    <IconButton onClick={() => closeSnackbar(key)} size="small">
      <Icon icon="codicon:chrome-close" color="#fff" fontSize={12} />
    </IconButton>
  );

  const dismissBtn = (key: any) => (
    <Button variant="outlined" onClick={() => closeSnackbar(key)} color="error" className="dismiss-snackbar">
      Dismiss
    </Button>
  );
  const showSnackbar = ({ message, options }: TSnackArgs) => {
    enqueueSnackbar(message, {
      variant: 'success',
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'center',
      },
      autoHideDuration: 4000,
      TransitionComponent: Slide,
      action: (key: any) => (options && options.variant !== 'error' ? closeBtn(key) : dismissBtn(key)),
      ...options,
    });
  };

  const showSuccessSnackbar = (args: TSnackArgs) => {
    showSnackbar({
      ...args,
      options: {
        className: 'snackbar-success',
        ...args.options,
      },
    });
  };

  const showErrorSnackbar = ({ message, options }: TSnackArgs) => {
    showSnackbar({
      message,
      options: {
        className: 'snackbar-error',
        ...options,
        variant: 'error',
      },
    });
  };

  const showWarningSnackbar = ({ message, options }: TSnackArgs) => {
    showSnackbar({
      message,
      options: {
        ...options,
        variant: 'warning',
      },
    });
  };

  const showInfoSnackbar = ({ message, options }: TSnackArgs) => {
    showSnackbar({
      message,
      options: {
        ...options,
        variant: 'info',
      },
    });
  };

  return {
    showSnackbar,
    showErrorSnackbar,
    showSuccessSnackbar,
    showWarningSnackbar,
    showInfoSnackbar,
  };
};

export default useSnackbarNotifications;
